import { InputNumber as $InputNumber } from 'antd';
import { InputNumberProps as $InputNumberProps } from 'antd/lib/input-number';
import React from 'react';

import { OnBlurCallback, OnChangeCallback } from '.';

export type InputElementProps = {
  inputType?: string;
  onBlur?: OnBlurCallback;
  onChange?: OnChangeCallback;
};
export type InputNumberProps = Omit<$InputNumberProps, 'type' | 'onBlur' | 'onChange'> & InputElementProps;

const InputNumber = React.memo(function InputNumber({ name, onBlur, onChange, ...props }: InputNumberProps) {
  const handleBlur =
    onBlur &&
    ((event: React.FocusEvent<HTMLInputElement>) => {
      const {
        target: { value },
      } = event;
      onBlur({ name, value: Number(value) });
    });
  const handleChange =
    onChange &&
    ((value?: number) => {
      onChange({ name, value });
    });
  return <$InputNumber {...props} name={name} onBlur={handleBlur} onChange={handleChange} />;
});

export default InputNumber;
